/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { BusinessType } from '../models/business-type';
import { GenericResponse } from '../models/generic-response';

/**
 * Trip report
 */
@Injectable({ providedIn: 'root' })
export class TripReportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `downloadTripReport()` */
  static readonly DownloadTripReportPath = '/api/v1/trip-reports/report';

  /**
   * to download trip report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadTripReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadTripReport$Response(
    params?: {
      /**
       * this adds a string search to the following fields:
       *   - from date
       */
      from?: string;

      /**
       * this adds a string search to the following fields:
       *   - to date
       */
      to?: string;

      /**
       * this adds a string search to the following fields:
       *   - client
       */
      clientId?: number;

      /**
       * This adds a filtering for reports by invoice type
       */
      invoiceType?: string;

      /**
       * This adds a filtering for reports by date type
       */
      dateType?: string;

      /**
       * This allows filtering invoices by their business type
       */
      businessType?: Array<BusinessType>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      TripReportService.DownloadTripReportPath,
      'get'
    );
    if (params) {
      rb.query('from', params.from, {});
      rb.query('to', params.to, {});
      rb.query('clientId', params.clientId, {});
      rb.query('invoiceType', params.invoiceType, {});
      rb.query('dateType', params.dateType, {});
      rb.query('businessType', params.businessType, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * to download trip report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadTripReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadTripReport(
    params?: {
      /**
       * this adds a string search to the following fields:
       *   - from date
       */
      from?: string;

      /**
       * this adds a string search to the following fields:
       *   - to date
       */
      to?: string;

      /**
       * this adds a string search to the following fields:
       *   - client
       */
      clientId?: number;

      /**
       * This adds a filtering for reports by invoice type
       */
      invoiceType?: string;

      /**
       * This adds a filtering for reports by date type
       */
      dateType?: string;

      /**
       * This allows filtering invoices by their business type
       */
      businessType?: Array<BusinessType>;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.downloadTripReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }
}
